import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Loads a private-preview SCI payload; 404 means "page does not exist", anything else is a load error.
export function useSciPreview(path) {
  const [state, setState] = useState({ loading: true, data: null, missing: false, error: false });
  const [attempt, setAttempt] = useState({ n: 0, quiet: false });
  useEffect(() => {
    let live = true;
    if (!attempt.quiet) setState({ loading: true, data: null, missing: false, error: false });
    api.get(path)
      .then((r) => live && setState({ loading: false, data: r.data, missing: false, error: false }))
      .catch((e) => live && setState({ loading: false, data: null, missing: e?.response?.status === 404, error: e?.response?.status !== 404 }));
    return () => { live = false; };
  }, [path, attempt]);
  return { ...state, retry: () => setAttempt((a) => ({ n: a.n + 1, quiet: false })), refresh: () => setAttempt((a) => ({ n: a.n + 1, quiet: true })) };
}

export const shortName = (c) => `${(c.university?.name || "").replace(/^University of /, "").replace(/, Berkeley$/, " Berkeley").replace("California Berkeley", "UC Berkeley")}`;

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");

export const GRANULARITY = {
  course: "This course",
  subject_at_provider: "This subject at this university",
  provider: "Whole university",
  programme_cip: "Field of study (CIP) at this university",
  subject_national: "Subject, all UK providers",
};
